import { render, staticRenderFns } from "./ArticleData.vue?vue&type=template&id=a07b2efa&"
import script from "./ArticleData.vue?vue&type=script&lang=js&"
export * from "./ArticleData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports